export const offeringPrompt = `

Maximum characters is 500

Tips for writing a great description

Include details about what you're offering in exchange for content. This might be a product, an experience or listing involvement. Tell bidders what makes it special and why they'll love it.


* Add information about your brand; your values, beliefs and what you stand for - people will bid for love not money when they get what you're all about.

* Explain the product, service or experience that you are offering

* The more you give, the more you get so be generous in the amount or the value of your offer

* Bullet points work well for the offer so you can cover off key points


Example description:

DABOO are passionate about engaging young minds and are on a mission to help children thrive as they learn about the world around them. Daboo offers a range of natural world topic, fully sustainable children’s books which are packaged in proven formats to engage in age specific ways. We’re offering:


- A box of 10 x pop up books, audio recordings and video games for Elementary aged children


Additional context:

Your brand is named {brand_name}
The title of the listing is {campaign_title}
`

export const lookingForPrompt = `

Maximum characters is 500

Tips for writing a great description

Example description:
* Our recommendation is to keep it broad. This will encourage all types of bids from different categories and areas

* You can limit if you want, but expect bids to be lower e.g. Fashion influencers to post 1 grid and 1 story


Example description:

Creators with a passion for travel who will create authentic content throughout their trip to create awareness of this amazing destination and encourages people to visit.


We'd like to see posts on Instagram and YouTube to highlight unique features of the trip, which include but are not limited to:


- The amazing views from the venue.

- Subtle shots of branded elements, such as the event logo (not blatant)

- Photos of perfectly served food and drink with a focus on the atmosphere and presentation


Additional context:

Your brand is named {brand_name}
The title of the listing is {campaign_title}
`